"use client";

import React from "react";
import { useAtom } from "jotai";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import ContinuePurchase from "@/components/order/continue-purchase";

import { showContinuePurchaseModalAtom } from "@/store/modal";

function ContinuePurchaseModal() {
  const [isOpen, setIsOpen] = useAtom(showContinuePurchaseModalAtom);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className="sm:max-w-4xl rounded-xl block space-y-4"
        forceMount
      >
        <DialogTitle>Continue Purchase</DialogTitle>
        <ContinuePurchase />
      </DialogContent>
    </Dialog>
  );
}

export default ContinuePurchaseModal;
